// src/pages/Welcome/MarketplaceSection.jsx
import React from 'react';
import { welcomeStyles } from './styles';
import ListingFilters from '../../components/ListingFilters';
import LoadingState from './LoadingState';
import EmptyState from './EmptyState';
import ListingsGrid from './ListingsGrid';

const MarketplaceSection = ({
  loading,
  filteredListings,
  filters,
  setFilters,
  search,
  setSearch,
  sort,
  setSort
}) => {
  return (
    <section style={welcomeStyles.marketplace}>
      <div style={welcomeStyles.marketplaceContent}>
        <div style={{ textAlign: 'center', marginBottom: welcomeStyles.sectionTitle.marginBottom }}>
          <h2 style={welcomeStyles.sectionTitle}>
            Discover Amazing Deals
          </h2>
          <p style={welcomeStyles.sectionSubtitle}>
            Find everything you need from textbooks to furniture, all from your fellow RedBirds
          </p>
        </div>
        
        {/* Enhanced Filters Section */}
        <div style={welcomeStyles.filtersContainer}>
          <ListingFilters
            filters={filters}
            setFilters={setFilters}
            search={search}
            setSearch={setSearch}
            sort={sort}
            setSort={setSort}
            showSearch={true}
            showSort={true}
          />
        </div>

        {/* Listings Content */}
        {loading ? (
          <LoadingState />
        ) : filteredListings.length === 0 ? (
          <EmptyState />
        ) : (
          <ListingsGrid listings={filteredListings} />
        )}
      </div>
    </section>
  );
};

export default MarketplaceSection;